import { Injectable, Inject } from 'ng-metadata/core';
import { HttpService } from '../infra/httpRequest/http.service';
import { ConfigurationUtil } from '../nddUtils/configurationUtil.service';
import { LinkedUserSelectorService } from './linkedUserSelector/linkedUserSelector.service';
import appConfigModule from '../appConfig/appConfig.module';
import { MappingTablesCache } from '../mappingTablesCache/mappingTablesCache.service';

@Injectable()
export class AccountService {

    private myAccountBaseUrl: any;
    private $http: ng.IHttpService;
    private resquestInProgress: Object = {};
    private DISPLAY_USER_SETTINGS: string = 'display_user_settings';

    //Default Paths. will be updated in constructor;
    private baseUrl = this.configurationUtil.isSuprima() ? '/primaws/rest/priv' : '/primo_library/libweb/webservices/rest/v1';
    private ilsServices = {
        'counters': {
            'path': this.baseUrl + '/myaccount/counters',
            'method': 'GET'
        },
        'loans': {
            'path': this.baseUrl + '/myaccount/loans',
            'method': 'GET'
        },
        'renew_loan': {
            'path': this.baseUrl + '/myaccount/renew_loans',
            'method': 'POST'
        },
        'renew_all_loans': {
            'path': this.baseUrl + '/myaccount/renew_all_loans',
            'method': 'POST'
        },
        'requests': {
            'path': this.baseUrl + '/myaccount/requests',
            'method': 'GET'
        },
        'deposits': {
            'path': this.baseUrl + '/myaccount/depositsInfo',
            'method': 'GET'
        },
        'representationInfo': {
            'path': this.baseUrl + '/myaccount/representationInfo',
            'method': 'GET'
        },
        'fines': {
            'path': this.baseUrl + '/myaccount/fines',
            'method': 'GET'
        },
        'cancel_requests': {
            'path': this.baseUrl + '/myaccount/cancel_requests',
            'method': 'POST'
        },
        'download_request': {
            'path': this.baseUrl + '/myaccount/documentDeliveryUrl',
            'method': 'GET'
        },
        'blocks_messages': {
            'path': this.baseUrl + '/myaccount/blocks_messages',
            'method': 'GET'
        },
        'personal_settings': {
            'path': this.baseUrl + '/myaccount/personal_settings',
            'method': 'GET'
        },
        'update_personal_settings': {
            'path': this.baseUrl + '/myaccount/update_personal_settings',
            'method': 'POST'
        },
        'submit_deposit': {
            'path': this.baseUrl + '/myaccount/submit_deposit',
            'method': 'POST'
        },
        'withdraw_deposit': {
            'path': this.baseUrl + '/myaccount/withdraw_deposit',
            'method': 'POST'
        },
        'collection': {
            'path': this.baseUrl + '/myaccount/collection',
            'method': 'GET'
        },
        'refreshLinkedUser': {
            'path': this.baseUrl + '/myaccount/refreshLinkedUser',
            'method': 'GET'
        },
        'renewDigitalLoan': {
            'path': this.baseUrl + '/myaccount/renewDigitalLoan',
            'method': 'POST'
        },
        'rapidoSaRenewRequest': {
            'path': this.baseUrl + '/myaccount/rapidoSaRenewRequest',
            'method':'POST'
        }
    };
    constructor(@Inject('restBaseURLs') private restBaseURLs,
        @Inject('$state') private $state: ng.ui.IStateService,
        private httpService: HttpService,
        private configurationUtil: ConfigurationUtil,
        private linkedUserSelectorService: LinkedUserSelectorService,
        private mappingTablesCache: MappingTablesCache) {
        this.myAccountBaseUrl = restBaseURLs.myAccountBaseURL;
        this.refreshRestPaths();
    }
    //****** PRM-46520-User settings: persist search history
    public showUserSetting() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DISPLAY_USER_SETTINGS }).length > 0;
    }

    public getServices() {
        return this.ilsServices;
    }

    /**
     * 
     * @param serviceName   The requested service. Should either match one of the services 
     *                      in this.ilsServices or one of the services that return from this.refreshRestPaths 
     * @param params        The parameters for the call. 
     *                      If this.ilsServices[serviceName].method = 'GET' than the parameters will be sent as query parameters
     *                      If this.ilsServices[serviceName].method = 'POST' than the parameters will be sent in the payload
     */
    public makeIlsRequest(serviceName: string, params: Object) {
        if (!params) {
            params = {};
        }
        if (this.linkedUserSelectorService.selectedInstitution) {
            if (!this.configurationUtil.isSuprima()) {
                params['linked_inst'] = this.linkedUserSelectorService.selectedInstitution.institutionCode || '';
            }
            else {
                params['inst_code'] = this.linkedUserSelectorService.selectedInstitution.institutionCode || '';
            }
            params['patron_id'] = this.linkedUserSelectorService.selectedInstitution.patronId || '';
        }
        let serviceDetails = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        let pathWithQueryParams = this.addQueryParamsToPath(serviceDetails, params);

        return this.httpService.call(serviceDetails.method, pathWithQueryParams, params)
            .then(
                (response) => {
                    return this.ilsRequestSuccess(response);
                },
                (error) => {
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally(() =>
                this.resquestInProgress[serviceName] = false
            );
    }

    addQueryParamsToPath(serviceDetails, params): string {
        let path = serviceDetails.path;
        if (serviceDetails.queryParams) {
            let queryParams = serviceDetails.queryParams;
            if (serviceDetails.method === 'GET') {
                // Filter query parameters that already exist
                queryParams = queryParams.filter(param => Object.keys(params).indexOf(param) === -1);
            }
            path += '?' + queryParams.map(param => this.$state.params[param] ? param + '=' + this.$state.params[param] : '').join('&');
        }
        return path;
    }

    public getDisplayBackToSearchLink() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            if (this.configurationUtil.getSummonOverAlma() === true) {
                return false;
            }
        }
        return true;
    }

    get requestInProgress() {
        return this.resquestInProgress || false;
    }

    private refreshRestPaths() {
        let ilsServices = this.ilsServices;
        this.httpService.call('GET', this.myAccountBaseUrl, {})
            .then(function (response) {
                let services = response;
                Object.keys(services).map(function (key) {
                    ilsServices[key] = services[key];
                });
            });
    }

    private ilsRequestSuccess(response) {
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }

}

export class StatusMsg {
    public isSuccess: boolean;
    public msg: string;

    constructor(isSuccess: boolean, msg: string) {
        this.isSuccess = isSuccess;
        this.msg = msg;
    }
}
export default [appConfigModule.name];



// WEBPACK FOOTER //
// ./src/main/webapp/components/account/account.service.ts